import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';

@Component({
  selector: 'app-airdisk-fleet-info',
  templateUrl: './airdisk-fleet-info.component.html',
  styleUrls: ['./airdisk-fleet-info.component.scss'],
  standalone: false
})
export class AirdiskFleetInfoComponent {
  private readonly destroy$ = new Subject<void>();

  @Input() adbDropDownData: any;
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.subscription = this.airdiskService.selectedOption$.subscribe((option) => {
      if (option) {
        this.isTractor = option === 'Tractor';
      } else {
        this.isTractor = true;
      }
    });

    this.airdiskService.fleetInfoData$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data != null) {
        this.airdiskFleetInfoForm.patchValue({
          fleetSize: data.fleetSize || 1000,
          tractorTradeInCycle: data.tractorTradeInCycle || 5,
          trailerTradeInCycle: data.trailerTradeInCycle || 10,
          averageAnnualUnitMilage: data.averageAnnualUnitMilage || 100000,
          drumToShoeReplacementFrequency: data.drumToShoeReplacementFrequency || 1,
          adbUpCharge: data.adbUpCharge.toFixed(2) || 2500.00,
          fleetMaintenanceLaborRate: data.fleetMaintenanceLaborRate.toFixed(2) || 130.00,
          adbResidualValueAtTradeIn: data.adbResidualValueAtTradeIn.toFixed(2) || 500.00,
          fleetDownTimeRate: data.fleetDownTimeRate.toFixed(2) || 1050.00,
        });

        if (this.isTractor) {
          this.airdiskFleetInfoForm.controls['totalNumberOfAxlesPerUnit'].setValue(3);
          this.airdiskFleetInfoForm.controls['adbResidualValueAtTradeIn'].setValue(500.00);
        } else {
          this.airdiskFleetInfoForm.controls['totalNumberOfAxlesPerUnit'].setValue(2);
          this.airdiskFleetInfoForm.controls['adbResidualValueAtTradeIn'].setValue(0);
        }
      }
    });
  }

  airdiskFleetInfoForm = new FormGroup({
    fleetSize: new FormControl(1000, { validators: Validators.required }),
    totalNumberOfAxlesPerUnit: new FormControl(3, { validators: Validators.required }),
    tractorTradeInCycle: new FormControl(5, { validators: Validators.required }),
    trailerTradeInCycle: new FormControl(10, { validators: Validators.required }),
    averageAnnualUnitMilage: new FormControl(100000, { validators: Validators.required }),
    drumToShoeReplacementFrequency: new FormControl(1, { validators: Validators.required }),
    adbUpCharge: new FormControl(2500.00, { validators: Validators.required }),
    fleetMaintenanceLaborRate: new FormControl(130.00, { validators: Validators.required }),
    adbResidualValueAtTradeIn: new FormControl(500.00, { validators: Validators.required }),
    fleetDownTimeRate: new FormControl(1050.00, { validators: Validators.required }),
  });
  get form() {
    return this.airdiskFleetInfoForm.controls;
  }
  endaSureNxt() {
    if (this.airdiskFleetInfoForm.valid) {
      this.airdiskFleetInfoForm.patchValue({
        adbUpCharge: Number(this.airdiskFleetInfoForm.controls['adbUpCharge'].value),
        fleetMaintenanceLaborRate: Number(this.airdiskFleetInfoForm.controls['fleetMaintenanceLaborRate'].value),
        adbResidualValueAtTradeIn: Number(this.airdiskFleetInfoForm.controls['adbResidualValueAtTradeIn'].value),
        fleetDownTimeRate: Number(this.airdiskFleetInfoForm.controls['fleetDownTimeRate'].value),
      });
      this.airdiskService.fleetInfoData$.next(this.airdiskFleetInfoForm.value);
      this.airdiskService.currentComponent$.next('fleetSafety');
    } else {
      this.airdiskFleetInfoForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }
  endaSureBack() {
    if (this.airdiskFleetInfoForm.valid) {
      this.airdiskService.currentComponent$.next('visitorInfo');
    } else {
      this.airdiskFleetInfoForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
  }
}
